<template>
  <tr>
    <td class="letter">{{ inputs.annexed.letter }}</td>
    <td class="name">
      <div class="col-md-12">{{ inputs.annexed.name }}</div>
      <div class="col-md-12" v-if="!inputs.is_charged">

      </div>

      <div class="col-md-12">
        <div class="row">
          <label class="col-sm-2"
            ><br><input
              type="checkbox"
              id="inputs_approved"
              v-model="inputs.is_approved"
              :required="true"
              disabled
            />
            Aprobar</label
          >
          <div class="col-sm-10">
            <app-input
            v-if="inputs.is_approved == '0'"
              type="textarea"
              v-model="inputs.observations"
              placeholder="Escribir observaciones"
              required
              disabled
            />
            <br>
            <app-badge
              v-if="inputs.is_approved == '0'"
              label="Documentación incompleta"
              className="badge badge-warning badge-lg"
              class="col-sm-12"
            />
            <app-badge
              v-if="inputs.is_approved == '1'"
              label="Documentación completa"
              className="badge badge-success badge-lg"
              class="col-sm-12"
            />
          </div>
        </div>
      </div>
    </td>
    <td class="attached-file">
      <button
        type="submit"
        class="btn btn-success mb-2"
        @click.prevent="openTab"
        v-if="inputs.is_charged"
      >
        <app-icon name="file" />
      </button>

    </td>
  </tr>
</template>

<script>
export default {
  name: "AnnexedFile",

  props: {
    inputs: Object,
  },

  data() {
    return { deleteModal: false };
  },

  methods: {
    deleteFile() {
      this.inputs.file = null;
      this.inputs.is_charged = 0;
    },

    confirmed() {
      this.deleteModal = false;
      this.inputs.file = null;
      this.inputs.is_charged = 0;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab() {
      const w = window.open(this.inputs.attached_file.path, "_blank");
      w.focus();
    },
  },
};
</script>
